import { render } from "./ShoppingCartView.vue?vue&type=template&id=2b7ccd80&scoped=true"
import script from "./ShoppingCartView.vue?vue&type=script&lang=js"
export * from "./ShoppingCartView.vue?vue&type=script&lang=js"

import "./ShoppingCartView.vue?vue&type=style&index=0&id=2b7ccd80&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2b7ccd80"

export default script